module.exports = __webpack_public_path__ + "static/media/logo-footer.4e46a8a2.png";